import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";

export const getPriceRangeRecommendationProperties = (
    selectedPropertyIds: number[] | null,
    recommendedProperties: IRecommendedProperty[] | undefined,
    mainProperty: IPropertyDetail
) => {
    const checkedPropertiesMinPrice =
        selectedPropertyIds && selectedPropertyIds.length > 0
            ? Math.min(
                  ...selectedPropertyIds.map((id) => {
                      if (id === mainProperty.id) return mainProperty.price || 0;
                      const recommendedProp = recommendedProperties?.find((prop) => prop.id === id);
                      return recommendedProp?.price || 0;
                  })
              )
            : mainProperty.price || 0;
    const checkedPropertiesMaxPrice =
        selectedPropertyIds && selectedPropertyIds.length > 0
            ? Math.max(
                  ...selectedPropertyIds.map((id) => {
                      if (id === mainProperty.id) return mainProperty.price || 0;
                      const recommendedProp = recommendedProperties?.find((prop) => prop.id === id);
                      return recommendedProp?.price || 0;
                  })
              )
            : mainProperty.price || 0;

    return {
        minPrice: checkedPropertiesMinPrice,
        maxPrice: checkedPropertiesMaxPrice
    };
};
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";

export const getPriceRangeRecommendationProperties = (
    selectedPropertyIds: number[] | null,
    recommendedProperties: IRecommendedProperty[] | undefined,
    mainProperty: IPropertyDetail
) => {
    const checkedPropertiesMinPrice =
        selectedPropertyIds && selectedPropertyIds.length > 0
            ? Math.min(
                  ...selectedPropertyIds.map((id) => {
                      if (id === mainProperty.id) return mainProperty.price || 0;
                      const recommendedProp = recommendedProperties?.find((prop) => prop.id === id);
                      return recommendedProp?.price || 0;
                  })
              )
            : mainProperty.price || 0;
    const checkedPropertiesMaxPrice =
        selectedPropertyIds && selectedPropertyIds.length > 0
            ? Math.max(
                  ...selectedPropertyIds.map((id) => {
                      if (id === mainProperty.id) return mainProperty.price || 0;
                      const recommendedProp = recommendedProperties?.find((prop) => prop.id === id);
                      return recommendedProp?.price || 0;
                  })
              )
            : mainProperty.price || 0;

    return {
        minPrice: checkedPropertiesMinPrice,
        maxPrice: checkedPropertiesMaxPrice
    };
};
